import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { RouteDrawer } from "#/components/route-drawer";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/admin/tickets/drawer")(
  {
    component: TicketDrawer,
    errorComponent: TicketDrawerError,
  },
);

function TicketDrawer() {
  const navigate = useNavigate();

  return (
    <RouteDrawer
      // Wider than the RouteDrawer default: the conversation thread + reply box need room.
      className="w-[calc(40rem+3rem)] supports-[-webkit-touch-callout:none]:w-[40rem]"
      onClose={() => {
        // Close by returning to the tickets overview, preserving the current search params.
        void navigate({
          from: Route.fullPath,
          to: "/$locale/{-$schoolyear}/admin/tickets",
          params: (prev) => prev,
          search: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        });
      }}
    >
      <Outlet />
    </RouteDrawer>
  );
}

function TicketDrawerError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
